<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'AUTH.FORGOT_PASSWORD' | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-button color="toolbar-button" (click)="switchView.emit({ view: 'login', config: { method: 'email' } })">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button color="toolbar-button" (click)="close.emit(false)">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  <p class="ion-padding ion-text-center">
    {{ 'AUTH.FORGOT_PASSWORD_EMAIL' | translate }}
  </p>

  <form [formGroup]="form" (submit)="submit()">
    <ion-list [inset]="true" lines="none">
      <ion-item>
        <ion-input
          type="email"
          name="email"
          formControlName="email"
          [label]="'AUTH.EMAIL' | translate"
          labelPlacement="fixed"
          [errorText]="'AUTH.ENTER_VALID_EMAIL' | translate"
          scAutofill
          autocomplete="email"
          email
          required></ion-input>
      </ion-item>
    </ion-list>

    <div class="ion-padding">
      <ion-button expand="block" type="submit" [disabled]="form.invalid || loading()">
        {{ 'AUTH.RESET_PASSWORD' | translate }}
      </ion-button>
    </div>
  </form>
</ion-content>
